// extracted by mini-css-extract-plugin
export default {"loading":"productList_loading__tlyBv","pcWrap":"productList_pcWrap__fE8v8"};